import React from 'react';
import { Alert, Box, Stack, Typography } from '@mui/material';
import OptimizerFactorExposureChart from './OptimizerFactorExposureChart';
import { numberText } from '../../utils/portfolioDesign';

import { SEARCHABLE_PORTFOLIO_RULES, portfolioRuleId } from './optimizerRuleRegistry';

export function parameterLabel(key, catalog = []) {
    const known = SEARCHABLE_PORTFOLIO_RULES.find((r) => portfolioRuleId(r) === key);
    if (known) return `${known.label} · ${known.unitLabel}`;
    const preference = { conviction: 'Conviction reward', risk: 'Risk objective reward', tracking: 'Closeness to sized ideas', turnover: 'Avoid trading' };
    if (key.startsWith('construction:')) return `${preference[key.split(':')[1]]} weight`;
    if (key === 'design:position_band_pct') return 'Maximum position deviation · % baseline';
    if (key === 'design:retention_pct') return 'Conviction floor · % baseline score';
    if (key === 'design:hedge_gross_pct_aum') return 'Hedge sleeve gross cap · % AUM';
    return catalog.find((r) => r.parameter === key)?.label ?? (key.startsWith('factor:') ? key.slice(7) : 'Constraint');
}

export function SelectedSettings({ candidate, study }) {
    if (!candidate) return null;
    return <Box sx={{ mt: 2 }}><Typography variant="subtitle2">Settings tested in this attempt</Typography>
        {!Object.keys(candidate.parameters ?? {}).length && <Typography variant="body2" color="text.secondary">{'The requested fixed settings.'}</Typography>}
        {Object.entries(candidate.parameters ?? {}).map(([key, value]) => <Stack direction="row" justifyContent="space-between" gap={1} key={key} sx={{ mt: 0.75 }}><Typography variant="caption" color="text.secondary">{parameterLabel(key, study.parameter_catalog)}</Typography><Typography variant="caption">{numberText(value, 4)}</Typography></Stack>)}
    </Box>;
}

export default function PortfolioDesignEvidence({ baseline, selected }) {
    if (!selected) return <Alert severity="info">Select a portfolio to compare its factor exposures.</Alert>;
    if (!Array.isArray(selected.factor_exposures_pct_aum)) return <Alert severity="info">Loading this portfolio’s factor exposures…</Alert>;
    return <OptimizerFactorExposureChart baseline={baseline} selected={selected} />;
}
